import { gql } from '@apollo/client';
import { categoryFragment } from '../fragments/category';

export const initializeOnboardingMutation = gql`
    ${categoryFragment}

    mutation InitializeOnboarding($timezone: String) {
        initializeOnboarding(timezone: $timezone) {
            category {
                ...CategoryFields
            }
            quests {
                id
                description
                dueDate
                timing
                timedInterval
                timerValueInMs
                name
                status
                tracking
                difficulty
                completedOn
                categoryId
                metric {
                    completed
                    xpPoints
                    completedTimes
                    timeSpentSec
                }
                goalId
                templateId
            }
            achievement {
                id
                name
                description
                categoryId
                rarity
                achievedOn
            }
        }
    }
`;
